import { Box, Button, TextField, Tooltip, Typography } from "@material-ui/core";
import React from "react";
import DayPicker from "react-day-picker";
import Modal from "src/components/Modal";
import {
  ADD_SEASON_BUTTON_LABEL,
  ADD_SEASON_MODAL_HEADER,
  ADD_SEASON_NAME_INPUT_LABEL,
  CLOSE_ADD_SEASON_MODAL_BUTTON_LABEL,
  DAY_PICKER_DETAILS,
} from "./constants";
import { IAddSeasonModalProps } from "./types";
import { getCanSubmit } from "./utils/get-can-submit/getCanSubmit";
import { Info } from "@material-ui/icons";

export const AddSeasonModal = ({
  handleSeasonNameChange,
  handleDayClick,
  isOpen,
  onClose,
  onSubmit,
  seasonName,
  seasonStartDate,
  submitting,
}: IAddSeasonModalProps) => {
  const canSubmit = getCanSubmit({ seasonName, submitting });
  return (
    <Modal open={isOpen} closeModal={onClose}>
      <Box display="flex" alignItems="center" marginBottom="0.5rem">
        <Typography variant="h4">{ADD_SEASON_MODAL_HEADER}</Typography>
        <Box marginLeft="1rem">
          <Tooltip placement="bottom" title={DAY_PICKER_DETAILS}>
            <Info />
          </Tooltip>
        </Box>
      </Box>
      <form onSubmit={onSubmit}>
        <Box display="flex" flexDirection="column" gridGap="1rem">
          <Box width="300px">
            <TextField
              label={ADD_SEASON_NAME_INPUT_LABEL}
              value={seasonName}
              onChange={handleSeasonNameChange}
            />
          </Box>
          <Box display="flex">
            <DayPicker
              onDayClick={handleDayClick}
              selectedDays={seasonStartDate}
            />
          </Box>
          <Box display="flex" justifyContent="space-between">
            <Button color="secondary" onClick={onClose} variant="contained">
              {CLOSE_ADD_SEASON_MODAL_BUTTON_LABEL}
            </Button>
            <Button
              type="submit"
              disabled={!canSubmit}
              variant="contained"
              color="primary"
            >
              {ADD_SEASON_BUTTON_LABEL}
            </Button>
          </Box>
        </Box>
      </form>
    </Modal>
  );
};



// WEBPACK FOOTER //
// ./src/pages/director/seasons/components/seasons-editor/components/add-season-modal/AddSeasonModal.tsx